export function AiIcon() {
    return (
        <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.333 1.49984V4.16651M14.6663 2.83317H11.9996M2.6663 10.8332V12.1665M3.33297 11.4998H1.99963M6.6243 9.83317C6.56478 9.60246 6.44453 9.39191 6.27605 9.22343C6.10757 9.05495 5.89702 8.93469 5.6663 8.87517L1.5763 7.82051C1.50652 7.8007 1.44511 7.75867 1.40138 7.7008C1.35765 7.64293 1.33398 7.57238 1.33398 7.49984C1.33398 7.4273 1.35765 7.35675 1.40138 7.29888C1.44511 7.24101 1.50652 7.19898 1.5763 7.17917L5.6663 6.12384C5.89693 6.06438 6.10743 5.94422 6.2759 5.77587C6.44438 5.60751 6.56468 5.3971 6.6243 5.16651L7.67897 1.07651C7.69857 1.00645 7.74056 0.944735 7.79851 0.90077C7.85647 0.856806 7.92722 0.833008 7.99997 0.833008C8.07271 0.833008 8.14346 0.856806 8.20142 0.90077C8.25938 0.944735 8.30136 1.00645 8.32097 1.07651L9.37497 5.16651C9.43449 5.39722 9.55474 5.60777 9.72322 5.77625C9.8917 5.94473 10.1023 6.06499 10.333 6.12451L14.423 7.17851C14.4933 7.19791 14.5553 7.23985 14.5995 7.29789C14.6437 7.35594 14.6677 7.42688 14.6677 7.49984C14.6677 7.5728 14.6437 7.64374 14.5995 7.70179C14.5553 7.75983 14.4933 7.80177 14.423 7.82117L10.333 8.87517C10.1023 8.93469 9.8917 9.05495 9.72322 9.22343C9.55474 9.39191 9.43449 9.60246 9.37497 9.83317L8.3203 13.9232C8.3007 13.9932 8.25871 14.0549 8.20075 14.0989C8.1428 14.1429 8.07205 14.1667 7.9993 14.1667C7.92656 14.1667 7.85581 14.1429 7.79785 14.0989C7.73989 14.0549 7.69791 13.9932 7.6783 13.9232L6.6243 9.83317Z"
                stroke="url(#paint0_linear_1392_932)"
                strokeWidth="1.04167"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_1392_932"
                    x1="1.33398"
                    y1="7.49984"
                    x2="14.6677"
                    y2="7.49984"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4C74E6" />
                    <stop offset="1" stopColor="#8D54E9" />
                </linearGradient>
            </defs>
        </svg>
    );
}
